/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useRef, useState } from 'react';
import { SEO_MULTICITY_TEMPLATE } from '../../constants/templateConstants';
import { getAppEnv } from '../../../config/env';
import './MultiCityPage.css';
import CabModifySearch from '../../components/CabModifySearch/CabModifySearch';
import {
  detectUserActivity,
  generateRequestId,
  isMobile,
  useSearchWidgetHooks
} from '../../utils/commonUtils';
import MultiCityPackages, {
  ScrollInView
} from '../../components/MultiCityPackages/MultiCityPackages';
import MulticityRouteInfo from '../../components/MulticityRouteInfo/MulticityRouteInfo';
import InboundCallBox from '../../components/InboundCall/InboundCallBox';
import { makeServiceDeskRequest } from '../../cabsAPIs';
import { SCROLL } from '../../constants/miscellaneousConstants';
import { trackMulticityPageEvent } from '../../utils/omnitureTracking';
import { yeildToMainThread } from '../../scheduler';
import { useMediaQuery } from 'react-responsive';
import AssistModal from '../../components/AssistModal';
import CallUsModal from '../../components/AssistModal/callUsModal';
import { EnvironmentVariables } from '../../types';
import DataLoaderError from '../../../server/errors/DataLoaderError';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import AppContextProvider from '../../AppContext';
import PageHeader from '../../components/PageHeader/PageHeader';
import Helmet from 'react-helmet';
import { setDateAsDatePlusN } from '../../utils/timeUtils';
import FooterSection from '../../components/Footer/Footer';

const ASSISTED_FORM_DATA_LS = 'ASSISTED_FORM_DATA_LS';
const env = getAppEnv();
const { PUBLIC_URL, DATA_LOADER_URL } = env.raw as EnvironmentVariables;
const getImageUrl = imageName => {
  return `${PUBLIC_URL}/static/public/${imageName}`;
};

const ThingsToKeepInMind = ({ thingToKeepInMind }) => {
  return (
    <div className="thingsToRemember leftRightPadding">
      <h2 className="thingsToRememberTitle">Things to keep in mind</h2>
      <ul className="listDisc paddingL15 ">
        {thingToKeepInMind.map(info => {
          return <li className="thingsToRememberInfo">{info}</li>;
        })}
      </ul>
    </div>
  );
};

const WhyChooseUs = ({ whyChooseUs, setShowModal }) => {
  return (
    <div className="WhyChooseUsContainer leftRightPadding">
      <div className="WhyChooseUs">
        <h2 className="WhyChooseUsTitle">Why choose us?</h2>
        {whyChooseUs &&
          whyChooseUs.length > 0 &&
          whyChooseUs.map(info => (
            <div className="alignCenter whyBookWithUsPoints">
              <img
                className="whyChooseUsImg lazyload"
                src={getImageUrl('thumbsUp.png')}
              />
              <div className="whyChooseUsPoints">{info}</div>
            </div>
          ))}
      </div>
      <div className="makeFlex perfectCenter">
        <div className="Assistance makeFlex">
          <div className="makeFlex perfectCenter">
            <img
              className="AssistanceImg lazyload"
              src={getImageUrl('assistance-call.png')}
            />
          </div>
          <div className="AssistanceInfo">
            <div className="AssistanceTitle">
              Looking to customise your plan?
            </div>
            <div className="AssistanceSubtitle">
              Reach out for personalized assistance and trip planning.
            </div>
            <div
              onClick={() => {
                setShowModal();
              }}
              className="AssistanceButon makeFlex perfectCenter pushBottom"
            >
              Talk to an expert
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

const KnowMore = ({ dhamInfo }) => {
  const dwebCardSizeInPx = 350;
  const scrollerRef = useRef(null);
  const windowRef = useRef(null);

  return (
    <div className="knowMore leftRightPadding">
      <h2 className="knowMoreTitle font24 latoBold blackText">
        Know more about Char Dham
      </h2>
      <ScrollInView
        scrollerRef={scrollerRef}
        windowRef={windowRef}
        dwebCardSizeInPx={dwebCardSizeInPx}
        component={
          <div ref={scrollerRef} className="knowMoreSection">
            <div ref={windowRef} className="knowMoreWindow">
              {dhamInfo.map(({ img, title, details, url }) => (
                <div
                  onClick={() => {
                    trackMulticityPageEvent(`Dham_Info_${title}_Clicked`);
                    window.location = Object(setDateAsDatePlusN(url, 3));
                  }}
                  className="knowMoreCard"
                >
                  <div className="knowMoreImg lazyload">
                    <img
                      style={{
                        width: '330px',
                        borderRadius: '20px',
                        marginBottom: '5px'
                      }}
                      src={`${PUBLIC_URL}/static/public/${img}`}
                    />
                  </div>
                  <div className="knowMoreDham">{title}</div>
                  <div className="knowMoreDhamDetails appendBottom20">
                    {details}
                  </div>
                  <div className="pushBottom viewCab makeFlex perfectCenter lineHeight34">
                    View Cab
                  </div>
                </div>
              ))}
            </div>
          </div>
        }
      />
    </div>
  );
};

const MulticityPage = ({ data }) => {
  const {
    packages,
    itineraryInfo,
    dhamInfo,
    whyChooseUs,
    thingToKeepInMind,
    assistanceData,
    templateData
  } = data;
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });
  const [showAssistantIc, setShowAssistantIc] = useState(false);
  const [showWhatsAppIcon, setWhatsAppIcon] = useState(false);
  const [showCallUsIcon, setCallUsIcon] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const {
    assistedFormOpenDelay = 10000,
    showTripAssistantButton = true,
    showTripAssistantButtonForDweb = true,
    showWhatsappWidget = true,
    whatsappWidgetDeeplink = 'https://wa.me/919951106499?text=Request%20ID%20MDRequest_id%20%0AHi,%20I%20am%20looking%20for%20a%20cab%20from%20Delhi%20to%20Agra',
    customerCareNumber = '01244781861',
    assistantWidgetText = 'You can Call Us or Chat via WhatsApp',
    showWhatsAppForAssistedForm = true,
    showCallUsWidget = false,
    showCallUsForAssistedForm = true,
    inboundCallText = 'Talk to agent (24x7)',
    inboundCallNumber = '0124 - 4781861',
    showInboundCallNumberInDesktop = true,
    showCallusModalMweb = false,
    callusModalOpenDelay = 10000,
    showInboundNumberOnAssistedForm = true
  } = assistanceData;

  const scrollPosition = useRef(0);
  const assistedFormLifeCycle = useRef(0);

  const { travelFor, pickUpTime, dropTime } = useSearchWidgetHooks(
    SEO_MULTICITY_TEMPLATE
  );

  const userActionDone = () => {
    return window?.localStorage?.getItem('userActionDone') == 'true';
  };

  const setShowModalWithDelay = async val => {
    if (
      isMobile()
        ? showCallusModalMweb || showTripAssistantButton
        : showTripAssistantButtonForDweb
    ) {
      await yeildToMainThread(() =>
        requestAnimationFrame(() => setShowModal(val))
      );
    }
  };
  const scrollableDivRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrolledHeight =
        window.pageYOffset || document.documentElement.scrollTop;

      // Access the ref's current element and change its style directly
      if (scrollableDivRef.current) {
        const scrolledHeight =
          window.pageYOffset || document.documentElement.scrollTop;
        const stickyWidget = document.getElementById('stickyWidget');

        if (scrolledHeight >= 200) {
          // @ts-ignore
          stickyWidget.classList.add('positionedSearchWidgetForStickyWidget');
        } else {
          // @ts-ignore
          stickyWidget.classList.remove(
            'positionedSearchWidgetForStickyWidget'
          );
        }
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const showModalConsideringScrollEvents = () => {
    if (assistedFormLifeCycle.current != 2 && !userActionDone()) {
      assistedFormLifeCycle.current = 2;
      setShowModalWithDelay(true);
      const eventName =
        showCallusModalMweb && showCallUsForAssistedForm && isMobile()
          ? 'Cab_SEO_Assisted_Call_Us_Form_Shown'
          : 'Cab_SEO_Assisted_Form_Shown';
      trackMulticityPageEvent(eventName);
    }
  };

  useEffect(() => {
    //
    const handleScroll = () => {
      scrollPosition.current = window.scrollY || window.pageYOffset;

      const scrollDownThreshold = isMobileDevice ? 500 : 900;
      const scrollUpThreshold = scrollDownThreshold - 100;

      if (
        scrollPosition.current > scrollDownThreshold &&
        assistedFormLifeCycle.current == 0
      ) {
        assistedFormLifeCycle.current = 1;
      } else if (
        scrollPosition.current < scrollUpThreshold &&
        assistedFormLifeCycle.current == 1
      ) {
        showModalConsideringScrollEvents();
      }
    };

    // If tripAssistantOpen is true in the query params then open form
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('tripAssistantOpen') === 'true') {
      showModalConsideringScrollEvents();
    }

    // Attach the scroll event listener
    window.addEventListener(SCROLL, handleScroll);
    if (window?.localStorage) {
      localStorage.removeItem(ASSISTED_FORM_DATA_LS);
    }

    openFormDueToInactivity();
    if (showCallUsWidget && isMobile()) {
      setTimeout(() => {
        trackMulticityPageEvent('Cab_SEO_Call_Us_Icon_Shown');
      }, 500);
    }

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener(SCROLL, handleScroll);
    };
  }, []);

  const openFormDueToInactivity = () => {
    const timeDelay = showCallusModalMweb
      ? callusModalOpenDelay
      : assistedFormOpenDelay;
    setTimeout(() => {
      if (window?.localStorage && assistedFormLifeCycle.current != 2) {
        if (
          !userActionDone() &&
          (isMobile()
            ? showTripAssistantButton || showCallusModalMweb
            : showTripAssistantButtonForDweb)
        ) {
          showModalConsideringScrollEvents();
        } else {
          // not show message should not be shown if modal is already shown
          const userAction = userActionDone();
          trackMulticityPageEvent(
            `Cab_SEO_Assisted_Form_Not_Shown_userActionDone_${userAction}`
          );
        }
      }
    }, timeDelay);
  };

  useEffect(() => {
    window.addEventListener(SCROLL, listenToScroll);
    detectUserActivity();
    return () => window.removeEventListener(SCROLL, listenToScroll);
  }, []);

  const listenToScroll = () => {
    const heightToShowFrom = 100;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > heightToShowFrom) {
      if (!(isMobileDevice && showModal)) {
        setShowAssistantIc(true);
        setWhatsAppIcon(true);
        setCallUsIcon(true);
      }
    } else {
      setShowAssistantIc(false);
      setWhatsAppIcon(false);
      setCallUsIcon(false);
    }
  };

  const fabInteraction = () => {
    return (
      <div
        className={` ${(() => {
          if (showTripAssistantButtonForDweb && showTripAssistantButton) {
            return '';
          } else if (showTripAssistantButton) {
            return 'mobileShow';
          } else if (showTripAssistantButtonForDweb) {
            return 'desktopShow';
          }
          return '';
        })()}`}
      >
        <div
          onClick={() => {
            trackMulticityPageEvent(
              `${
                showModal
                  ? 'Cab_SEO_Assisted_Form_Closed'
                  : 'Cab_SEO_Assisted_Form_CTA_Click'
              }`
            );
            setShowModalWithDelay(!showModal);
            assistedFormLifeCycle.current = 2; // keeping this 2 as for both the cases Closed and Clicked, Assisted form will be shown
          }}
          className={`fabInteraction ${
            showModal && isMobileDevice
              ? 'showCrossIc'
              : showAssistantIc
              ? 'showIc'
              : ''
          }`}
        >
          <div className={`icContainer ${showModal ? 'showCrossIc' : ''}`} />
          {true && <span>Trip Assistant</span>}
        </div>
      </div>
    );
  };

  const callUsForm = () => {
    return (
      <div
        className={` ${(() => {
          if (showCallusModalMweb) {
            return '';
          }
          return '';
        })()}`}
      >
        <div
          onClick={() => {
            trackMulticityPageEvent(
              `${
                showModal
                  ? 'Cab_SEO_Assisted_Call_Us_Form_Closed'
                  : 'Cab_SEO_Assisted_Form_CTA_Click'
              }`
            );
            setShowModalWithDelay(!showModal);
            assistedFormLifeCycle.current = 2; // keeping this 2 as for both the cases Closed and Clicked, Assisted form will be shown
          }}
          className={`${
            showModal && isMobileDevice
              ? 'fabInteraction showCrossIc'
              : showAssistantIc
              ? 'showIc'
              : ''
          }`}
        >
          <div className={`icContainer ${showModal ? 'showCrossIc' : ''}`} />
        </div>
      </div>
    );
  };

  const onWhatsAppIconClick = () => {
    const requestId = generateRequestId();
    const pageName = 'seo_multicity_page';
    makeServiceDeskRequest(requestId, pageName);
    const whatsAppChatLinkWithRequestId = whatsappWidgetDeeplink
      ? whatsappWidgetDeeplink.replace('MDRequest_id', requestId)
      : '';
    if (whatsAppChatLinkWithRequestId)
      window.location.href = whatsAppChatLinkWithRequestId;
  };

  const onCallUsIconClick = () => {
    window.open(`tel:${customerCareNumber}`, '_blank');
  };

  return (
    <AppContextProvider
      omniUrlArgs={`source=${SEO_MULTICITY_TEMPLATE}`}
      trackTemplateEvent={trackMulticityPageEvent}
      selectedKnowMoreDetailsForMobile={null}
      setSelectedKnowMoreDetailsForMobile={null}
    >
      <div className="chardhamBackgroundImage desktopShow">
        <div className="makeFlex perfectCenter">
          <div className="positionedChardhamHeader">
            <div className="font36 latoBlack blackText makeFlex perfectCenter">
              Char Dham cabs
            </div>
            <div className="font28 latoRegular blackText makeFlex perfectCenter">
              Book Comfortable Cabs for your Custom Travel Needs
            </div>
          </div>
        </div>
      </div>
      <div id="Chardham" className="cabSeoDtPage">
        <div
          style={{ zIndex: 1 }}
          ref={scrollableDivRef}
          id="stickyWidget"
          className={`desktopShow positionedSearchWidget`}
        >
          <CabModifySearch
            forwardDate={3}
            mcPageStyle={true}
            pickupTime={pickUpTime}
            defaultTripType={travelFor}
            returnTime={dropTime}
            returnCloseFlagDefault={false}
            sourceCityCode="DL"
            sourceCityName="Delhi"
            destinationCityCode="XBA"
            destinationCityName="Badrinath"
            isMobileDevice={false}
            title={`MC Cabs`}
          />
        </div>

        <div>
          {isMobile() && showWhatsappWidget && (
            <div
              className={`${!showModal ? 'whatsApp' : ''} ${
                showModal ? '' : showWhatsAppIcon ? 'showWhatsAppIcon' : ''
              }`}
              onClick={() => {
                onWhatsAppIconClick();
                trackMulticityPageEvent(
                  'Cab_SEO_WhatsApp_Assisted_Icon_Clicked'
                );
              }}
            >
              <div
                className={`${!showModal ? 'whatsaAppIconContainer' : ''}`}
              />
              {true && !showModal && <span>Chat with us</span>}
            </div>
          )}
        </div>
        <div>
          {isMobile() && showCallUsWidget && customerCareNumber && (
            <div
              className={`${!showModal ? 'callUs' : ''} ${
                showModal ? '' : showCallUsIcon ? 'showCallUsIcon' : ''
              }`}
              onClick={() => {
                onCallUsIconClick();
                trackMulticityPageEvent('Cab_SEO_Call_Us_Icon_Clicked');
              }}
            >
              <div className={`${!showModal ? 'callUsIconContainer' : ''}`} />
              {true && !showModal && <span>Call us now</span>}
            </div>
          )}
        </div>
        {(isMobile() ? (
          showTripAssistantButton
        ) : (
          showTripAssistantButtonForDweb
        )) ? (
          fabInteraction()
        ) : (
          <div></div>
        )}
        {showCallusModalMweb && callUsForm()}
        {showModal &&
          (isMobile()
            ? showTripAssistantButton
            : showTripAssistantButtonForDweb) && (
            <AssistModal
              setShowModal={val => setShowModalWithDelay(val)}
              trackTemplateEvent={trackMulticityPageEvent}
              sourceCity={'Delhi'}
              destinationCity={'Badrinath'}
              showWhatsAppForAssistedForm={showWhatsAppForAssistedForm}
              showCallUsForAssistedForm={showCallUsForAssistedForm}
              customerCareNumber={customerCareNumber || ''}
              assistantWidgetText={assistantWidgetText}
              onCallUsIconClick={onCallUsIconClick}
              onWhatsAppIconClick={onWhatsAppIconClick}
              showInboundNumberOnAssistedForm={
                showInboundNumberOnAssistedForm || true
              }
              inboundCallNumber={inboundCallNumber}
              inboundCallText={inboundCallText}
            />
          )}
        {showModal && isMobile() && showCallusModalMweb && (
          <CallUsModal
            setShowModal={val => setShowModalWithDelay(val)}
            trackTemplateEvent={trackMulticityPageEvent}
            showWhatsAppForAssistedForm={showWhatsAppForAssistedForm}
            showCallUsForAssistedForm={showCallUsForAssistedForm}
            customerCareNumber={customerCareNumber}
            assistantWidgetText={assistantWidgetText}
            onCallUsIconClick={onCallUsIconClick}
            onWhatsAppIconClick={onWhatsAppIconClick}
            showModal={showModal}
          />
        )}
        <div className="cabSeoDtPage">
          <div className={`mobileShow makeSticky`}>
            <CabModifySearch
              sourceCityCode="DL"
              sourceCityName="Delhi"
              forwardDate={3}
              pickupTime={pickUpTime}
              defaultTripType={travelFor}
              returnTime={dropTime}
              returnCloseFlagDefault={false}
              destinationCityCode="XBA"
              destinationCityName="Badrinath"
              isMobileDevice={true}
              title={`Char Dham Cabs`}
            />
          </div>
        </div>
        <div className="multicityContainer">
          <Helmet>
            <title>{templateData.metaTitle}</title>
            <meta name="description" content={templateData.metaDescription} />
            <meta name="keywords" content={templateData.metaKeywords} />
            <link rel="canonical" href={templateData.sampleUrl} />
          </Helmet>
          <div className="leftRightPaddingBreadCrumb">
            <BreadCrumb breadcrumb={templateData.breadcrumb} />
            <div className="">
              <PageHeader
                title={templateData.h1Title}
                extraInfo={templateData.metaDescription}
                isMobileDevice={isMobileDevice}
                url={templateData.sampleUrl}
              />
            </div>
          </div>
          <div className="makeFlex mcHeader leftRightPadding">
            <div className="dhamSelectHeader desktopShow">
              <span className="font24 latoRegular blackText">
                Explore price trips from{' '}
              </span>
              <span
                style={{ textDecoration: 'underline' }}
                className="font24 latoBold darkGreyText"
              >
                New Delhi
              </span>
            </div>
            <div className="inboundCallBox">
              {showInboundCallNumberInDesktop ? (
                <InboundCallBox
                  inboundCallText={'Talk to agent (24x7)'}
                  inboundCallNumber={'0124 - 4781861'}
                />
              ) : null}
            </div>
          </div>
          <MultiCityPackages packages={packages} />
          <WhyChooseUs
            whyChooseUs={whyChooseUs}
            setShowModal={() => {
              trackMulticityPageEvent('Talk_to_an_expert_Click');
              setShowModalWithDelay(!showModal);
            }}
          />

          <div className="whiteBackGroundColor">
            <img
              className="RouteImg makeFlex horizontalCenter lazyload"
              src={`${PUBLIC_URL}/static/public/chardham-route.webp`}
            />
          </div>
          <MulticityRouteInfo itineraryInfo={itineraryInfo} />
          {thingToKeepInMind && thingToKeepInMind.length > 0 ? (
            <ThingsToKeepInMind thingToKeepInMind={thingToKeepInMind} />
          ) : null}
          {dhamInfo && dhamInfo.length > 0 ? (
            <KnowMore dhamInfo={dhamInfo} />
          ) : null}
          <FooterSection template={templateData} />
        </div>
      </div>
    </AppContextProvider>
  );
};

MulticityPage.fetchData = async (_, match, urlObj) => {
  const {
    params: { multiCityId }
  } = match;

  const url = `${DATA_LOADER_URL}/api/multiCityTemplateData/${multiCityId}?${urlObj.query}`;
  let responseData;
  const response = await fetch(url);
  const textResponse = await response.text();

  try {
    responseData = JSON.parse(textResponse);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new Error('JSON parse exception: ' + textResponse);
  }
  if (responseData.status !== 'SUCCESS') {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new DataLoaderError(
      `Unable to fetch city details of ${multiCityId}`,
      responseData.error
    );
  }

  const templateData = {
    footerData: responseData.footerData,
    templateName: SEO_MULTICITY_TEMPLATE,
    metaTitle: 'Char Dham Cabs - Safe, Comfortable Pilgrimage Taxi Service',
    sampleUrl:
      'https://www.makemytrip.com/car-rental/char-dham-yatra-cabs-multiple-stops.html',
    metaDescription:
      'Book Char Dham Cabs & travel with ease. Our reliable Char Dham Taxi provides safe & comfortable cabs to Yamunotri, Gangotri, Kedarnath & Badrinath.',
    metaKeywords:
      'Char Dham Cabs, Char Dham Taxi, Char Dham Cab, Do Dham Cabs, Do Dham Taxi, Do Dham Cab',
    analytics: `var s=s_gi('mmtprod');
              s.pageName="seo:domestic cabs: chardham";
              s.channel="seotemplate domestic cabs funnel";
              s.server = window.location.hostname;
              s.prop24="domestic cabs";
              if(typeof(mboxLoadSCPlugin) != "undefined" ){
              mboxLoadSCPlugin(s);
              }
              var s_code=s.t();if(s_code)document.write(s_code);`,
    h1Title: 'Char Dham Cabs',
    // extraInfo: '',
    // bannerMobile: 'top',
    // bannerDesktop: 'top',
    breadcrumb: [
      {
        displayString: 'Home',
        redirectionUrl: 'https://www.makemytrip.com/'
      },
      {
        displayString: 'Cabs',
        redirectionUrl: 'https://www.makemytrip.com/cabs/'
      },
      {
        displayString: ' Char Dham Cabs',
        redirectionUrl:
          'https://www.makemytrip.com/car-rental/chardham-yatra-cabs.html'
      }
    ]
  };

  return {
    ...responseData,
    templateData,
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey: 'HTML_CMC_' + multiCityId
  };
};

export default MulticityPage;
